var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.doughnutChartVisitacaoAtrativoCity).length > 0)?_c('div',[_c('doughnut-chart',{attrs:{"id":"bar-chart-visitacao","height":_vm.height,"chart-data":_vm.doughnutChartVisitacaoAtrativoCity.chartData,"extra-options":_vm.doughnutChartVisitacaoAtrativoCity.extraOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }